import { useQuery } from "@connectrpc/connect-query";
import { protocolStats } from "@uniswap/client-explore/dist/uniswap/explore/v1/service-ExploreStatsService_connectquery";
import { uniswapGetTransport } from "uniswap/src/data/rest/base";
export function useProtocolStatsQuery(input) {
  return useQuery(protocolStats, input, { transport: uniswapGetTransport, staleTime: 60 * 60 * 1e3 });
}
